"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SchemaWrapper_1 = require("./SchemaWrapper");
var JSchema_1 = require("./JSchema");
var schemaMixin = {
    // beforeCreate() { },
    created: function () {
        var vm = this;
        var options = vm.$options;
        var schema = options.schema;
        if (schema) {
            // const schOptions = options.schemaOptions || {};
            var wrapobj = new SchemaWrapper_1.SchemaWrapper(this.constructor, options.schemaOptions);
            // tslint:disable-next-line: no-console
            if (options.external) {
                // console.log('set external', options.external);
                wrapobj.external = vm.$external = options.external;
            }
            else {
                // wrapobj.basedata = vm.$external
            }
            vm.$options._schemawrapper = wrapobj;
            // if (options.form) {
            vm.$form = wrapobj.form = vm.form || options.form || {};
            // vm.$form = options.form;
            // }
            wrapobj.asyncArrays = false;
            // merge schema
            var schema2 = null;
            // let fixtime = new Date().getTime();
            if (process.env.NODE_ENV === 'development') {
                console.time('schema fixing time');
            }
            var fixOptions = Object.assign({}, JSchema_1.fixSchemaDefaultOptions);
            if ((options.schemaOptions) && (options.schemaOptions.arrayItemGuidField !== undefined)) {
                fixOptions.arrayItemGuidField = options.schemaOptions.arrayItemGuidField;
            }
            if (!Array.isArray(schema)) {
                schema = [schema];
            }
            else {
                schema = schema.slice(0);
            }
            if (options.beforeFixSchema) {
                options.beforeFixSchema(schema, fixOptions);
            }
            schema2 = JSchema_1.fixAndMergeSchema(schema, fixOptions);
            // let ooo = JSON.stringify(schema2);
            if (process.env.NODE_ENV === 'development') {
                console.timeEnd('schema fixing time');
            }
            // console.log('schema fixing time', new Date().getTime() - fixtime);
            // const stime = new Date().getTime();
            if (process.env.NODE_ENV === 'development') {
                console.time('wrapping schema');
            }
            // for (let i = 0; i < 100; i++) {
            // Object.defineProperty(this,"$schema",{
            //    enumerable: true,
            //    get: wrapobj.wrap(this, "model", schema)
            // })
            if (vm.model !== undefined) {
                if (vm.model === null) {
                    // tworzenie domyslnego
                    vm.model = JSchema_1.defaultValue(schema2, true);
                }
                else {
                    if (process.env.NODE_ENV === 'development') {
                        console.time('fixData');
                    }
                    var fixed = JSchema_1.fixData(schema2, vm.model, wrapobj.Vue);
                    if (process.env.NODE_ENV === 'development') {
                        console.timeEnd('fixData');
                        if (fixed) {
                            console.log('fixed fields: ' + fixed);
                        }
                    }
                }
                if (options.beforeSchema) {
                    options.beforeSchema(vm.model, schema2, wrapobj.options);
                }
                if (process.env.NODE_ENV === 'development') {
                    console.log('$schema.options', wrapobj.options);
                }
                // console.log('wrapping model', vm.model);
                vm.$schema = wrapobj.wrap(vm, 'model', schema2);
            }
            else {
                if (options.beforeSchema) {
                    options.beforeSchema(vm._data, schema2, wrapobj.options);
                }
                if (process.env.NODE_ENV === 'development') {
                    console.log('$schema.options', wrapobj.options);
                }
                vm.$schema = wrapobj.wrap(vm, '_data', schema2);
            }
            if (options.afterSchema) {
                options.afterSchema(vm.$schema);
            }
            if (process.env.NODE_ENV === 'development') {
                console.timeEnd('wrapping schema');
            }
            // console.log('wrapping schema', vm.$schema);
            // }
            // tslint:disable-next-line: no-console
            // console.log('wraptime', new Date().getTime() - stime, vm.$schema);
        }
    },
    beforeDestroy: function () {
        var vm = this;
        var wrapobj = vm.$options._schemawrapper;
        if (wrapobj) {
            wrapobj.clear();
        }
    },
    /*
    destroyed() {
        const vm: any = this as any;
    },
    */
    methods: {
        allComponents: function (parentComponent, componentTag, result) {
            if (parentComponent.$vnode.componentOptions.tag === componentTag) {
                result.push(parentComponent);
                return result;
            }
            if (parentComponent.$children) {
                var l = parentComponent.$children.length;
                for (var i = 0; i < l; i++) {
                    this.allComponents(parentComponent.$children[i], componentTag, result);
                }
            }
            return result;
        },
        validateSection: function (section) {
            var stime = new Date().getTime();
            var self = this;
            var ss = null;
            for (var i = 0; i < self.$children.length; i++) {
                var component = self.$children[i];
                if (component.$vnode.componentOptions.tag === 'w-section') {
                    if (component.section === section) {
                        ss = component;
                        break;
                    }
                }
            }
            if (ss === null) {
                return [];
            }
            var result = [];
            var traverseError = function (parentComponent) {
                if (parentComponent.$vnode.componentOptions.tag === 'w-error') {
                    var model = parentComponent.model;
                    var vres = model.$validate();
                    if (vres) {
                        result.push(parentComponent);
                    }
                    // result.push(parentComponent);
                    // return result;
                }
                if (parentComponent.$children) {
                    var l = parentComponent.$children.length;
                    for (var i = 0; i < l; i++) {
                        traverseError(parentComponent.$children[i]);
                    }
                }
            };
            traverseError(ss);
            // console.log('validateSection', new Date().getTime() - stime, result.length, result[0]);
            // result[20].$emit('focus');
            return result;
        },
        resetSection: function (section) {
            var stime = new Date().getTime();
            var self = this;
            var ss = null;
            for (var i = 0; i < self.$children.length; i++) {
                var component = self.$children[i];
                if (component.$vnode.componentOptions.tag === 'w-section') {
                    if (component.section === section) {
                        ss = component;
                        break;
                    }
                }
            }
            if (ss === null) {
                return [];
            }
            var result = [];
            var traverseError = function (parentComponent) {
                if (parentComponent.$vnode.componentOptions.tag === 'w-error') {
                    var model = parentComponent.model;
                    if (model.$error) {
                        model.$reset();
                        result.push(parentComponent);
                    }
                }
                if (parentComponent.$children) {
                    var l = parentComponent.$children.length;
                    for (var i = 0; i < l; i++) {
                        traverseError(parentComponent.$children[i]);
                    }
                }
            };
            traverseError(ss);
            // console.log('validateSection', new Date().getTime() - stime, result.length, result[0]);
            // result[20].$emit('focus');
            return result;
        }
    }
    /*
      directives: {
          schema: {
              bind: (el: any, binding: any, vnode: any) => {
                  if (vnode && vnode.componentInstance && vnode.componentInstance.setModel) {
                      vnode.componentInstance.setModel(binding.value, binding.modifiers);

                  }
              },
          },
      },
      */
};
exports.default = schemaMixin;
//# sourceMappingURL=schemaMixin.js.map